import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

export interface IPaginate {
  // 現在のページ数
  currentPage: number;
  // ページの最大数
  pageLength: number;
  // 表示する行数の数
  itemLength: number;
  // 実際の行数
  itemCount: number;
}

interface IPaginateButton {
  title: string;
  page?: number;
  current: boolean;
}

@Component({
    selector: 'app-paginate',
    templateUrl: './paginate.component.html',
    styleUrls: ['./paginate.component.scss'],
    standalone: false
})
export class PaginateComponent implements OnChanges {

  @Input() paginate: IPaginate;
  @Output() goto = new EventEmitter();

  public pageButtons: IPaginateButton[];
  public marginNum: number[];

  get isDiabledBack() {
    return this.paginate.itemCount === 0
      || this.paginate.currentPage === 0
      || this.pageButtons.length === 1;
  }

  get isDiabledFirst() {
    return this.isDiabledBack;
  }

  get isDiabledNext() {
    return this.paginate.itemCount === 0
      || this.paginate.currentPage === this.paginate.pageLength - 1
      || this.pageButtons.length === 1;
  }

  get isDiabledLast() {
    return this.isDiabledNext;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['paginate'] || !changes['paginate'].currentValue) {
      return null;
    }
    const p = changes['paginate'].currentValue as IPaginate;

    // Button情報の生成
    this.pageButtons = this.makeButton(p);
  }

  private makeButton(p: IPaginate) {
    const maxShowButton = 6;
    const buttons: IPaginateButton[] = [];
    const current = p.currentPage;

    // ページ数が最大表示できる数に収まっている場合
    if (p.pageLength <= maxShowButton) {
      for (let i = 0; i < p.pageLength; i++) {
        buttons.push({ title: `${i + 1}`, page: i, current: current === i });
      }
      return buttons;
    }
    // FIXME: ロジックカオス直したい。
    let endOf = false, startOf = false;
    const titleCountUp = (current === p.pageLength) ? 0 : 1;
    const pageCountDown = (current === p.pageLength) ? 1 : 0;
    // 選択されたページ情報を保存
    buttons.push({ title: `${current + titleCountUp}`, page: current - pageCountDown, current: true });
    for (let i = current + 1; i < current + 3; i++) {
      // 表示領域を超えたらfor終了
      if (p.pageLength <= i) { break; }
      endOf = true;
      buttons.push({ title: `${i + 1}`, page: i, current: false });
    }
    for (let i = current - 1; i > current - 3; i--) {
      // 0未満になったらfor終了
      if (i < 0) { break; }
      startOf = true;
      buttons.unshift({ title: `${i + titleCountUp}`, page: i - pageCountDown, current: false });
    }

    if (startOf && buttons[0].page !== 0) {
      if (buttons[0].page !== 1) { buttons.unshift({ title: `…`, current: false }); }
      buttons.unshift({ title: `${1}`, page: 0, current: false });
    }

    if (endOf && buttons[buttons.length - 1].page !== p.pageLength - 1) {
      if (buttons[buttons.length - 1].page !== p.pageLength - 2) { buttons.push({ title: `…`, current: false }); }
      buttons.push({ title: `${p.pageLength}`, page: p.pageLength - 1, current: false });
    }
    return buttons;
  }

  onClickGoto(page: number) {
    if (page === undefined) { return; }
    this.goto.emit(page);
  }
}
